module.exports = __webpack_public_path__ + "img/checked.cb7e4ff6.png";